import { useTranslation } from 'react-i18next';
import { Redo2, Undo2 } from 'lucide-react';
import type { ThemeHistory } from '../../hooks/useThemeHistory';

/** Undo / position / redo cluster for the idea box; hidden until there is history. */
export default function ThemeHistoryControls({ themeHistory, tone = 'light' }: { themeHistory: ThemeHistory; tone?: 'light' | 'dark' }) {
  const { t } = useTranslation();
  if (themeHistory.total <= 1) return null;
  const dark = tone === 'dark';
  const btn = dark
    ? 'w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white/80 hover:bg-primary/30 hover:text-white transition-colors disabled:opacity-40 disabled:hover:bg-white/10 disabled:hover:text-white/80'
    : 'w-10 h-10 flex items-center justify-center rounded-full bg-stone-100 hover:bg-primary/10 hover:text-primary transition-colors disabled:opacity-50 disabled:hover:bg-stone-100 disabled:hover:text-current';
  return (
    <div className="flex items-center gap-1.5" data-testid="theme-history">
      <button type="button" onClick={themeHistory.undo} disabled={!themeHistory.canUndo} title={t('create.undoIdea')} aria-label={t('create.undoIdea')} className={btn} data-testid="theme-undo">
        <Undo2 className="w-3.5 h-3.5" />
      </button>
      <span className={`text-xs tabular-nums ${dark ? 'text-white/60' : 'text-muted-foreground'}`} data-testid="theme-history-pos">
        {t('create.historyCounter', { position: themeHistory.position, total: themeHistory.total })}
      </span>
      <button type="button" onClick={themeHistory.redo} disabled={!themeHistory.canRedo} title={t('create.redoIdea')} aria-label={t('create.redoIdea')} className={btn} data-testid="theme-redo">
        <Redo2 className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
